import { PageController } from '@client/components/_core/layout/PageController';
import { DemoTemplateWizard } from '@client/components/admin-console/demo-template/DemoTemplateWizard';
import { getFlag } from '@client/utils/feature-flags';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { Sparkles } from 'lucide-react';

const FLAG_KEY = 'admin-demo-org-templates';

export const Route = createFileRoute('/admin-console/organisation-management/new-from-template')({
    staticData: {
        permissions: ['admin_orgs:create'],
        breadcrumb: { title: 'Create demo org' },
        ui: {
            icon: Sparkles,
            title: 'Create demo org from template',
            widthVariant: 'compact',
            menuDescription: 'Stamp out a fully-seeded demo tenant for a sales prospect',
        },
    },
    beforeLoad: async (): Promise<void> => {
        // Defence-in-depth: even with a permission match, hide the wizard when the
        // PostHog flag is off. The server-side procedures also 403 in production.
        if (!(await getFlag(FLAG_KEY, false))) {
            throw redirect({ to: '/admin-console/organisation-management/organisations', replace: true });
        }
    },
    component: NewFromTemplate,
});

function NewFromTemplate() {
    return (
        <PageController route={Route}>
            <DemoTemplateWizard />
        </PageController>
    );
}
